import HBIcon from "@/components/HBIcon";
import useAppStore from "@/context/store";
import { Dropdown } from "antd";
import classNames from "classnames";
import { useMemo, useState } from "react";

import styles from "./toolSelect.module.less";
export default function ToolSelect(props) {
  const { onChange, value, disabled, show } = props;
  const { aiLinkMap } = useAppStore(({ aiLinkMap }) => ({ aiLinkMap }));
  const onSelect = (value) => {
    onChange(value);
  };
  const [visible, setVisible] = useState(false);
  const currentName = useMemo(() => {
    if (!value) {
      return "创作工具";
    }
    let current = aiLinkMap?.find((item) => {
      return item.value === value;
    });
    return current?.name || "其他";
  }, [value, aiLinkMap]);
  const menu = (
    <div className={styles.menu}>
      <div className={styles.list}>
        {aiLinkMap?.map((category) => (
          <a
            key={category.value}
            className={classNames(styles.item, {
              [styles.selected]: category.value === value,
            })}
            onClick={() => onSelect(category.value)}
            data-gd-click="button_click"
            data-button-name="修改分类"
            data-content-source={category.value}
          >
            <span>{category.name}</span>
            {category.value === value && (
              <HBIcon className={styles.icon} type="ic_check" />
            )}
          </a>
        ))}
      </div>
    </div>
  );
  return (
    <Dropdown
      overlay={menu}
      disabled={disabled}
      placement="bottomLeft"
      trigger="hover"
      visible={visible}
      onVisibleChange={(visible) => setVisible(visible)}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
    >
      <div
        className={classNames(styles.link, {
          [styles.disabled]: disabled,
          [styles.hide]: !show,
        })}
      >
        <span className={styles.text}>{currentName}</span>
        {!disabled && (
          <HBIcon
            className={classNames(styles.icon, {
              [styles.reverse]: visible,
            })}
            type="ic_arrow_drop_down"
          />
        )}
      </div>
    </Dropdown>
  );
}
